import { AnimatePresence, motion } from 'framer-motion';
import { Icon } from './icons';

interface AiThinkingIndicatorProps {
  status: string;
  fallback: string;
}

export default function AiThinkingIndicator({ status, fallback }: AiThinkingIndicatorProps) {
  return (
    <span className="ai-thinking">
      <Icon name="sparkle" size={14} className="ai-thinking-sparkle" />
      <AnimatePresence mode="wait">
        <motion.span
          key={status || fallback}
          className="ai-thinking-text"
          initial={{ opacity: 0, y: 4 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -4 }}
          transition={{ duration: 0.16 }}
        >
          {status || fallback}
        </motion.span>
      </AnimatePresence>
    </span>
  );
}
